<section>
    <div *ngIf="!showCoverageNotAvailable; else noCoverageTemplate" class="result">
        <div [ngClass]="enableCbmGeminiTR4 ? 'new-card-container' : 'card-container'">
            <div class="card" *ngIf="showInitialState">
                <p class="header">{{ pageData.gtpCardHeader }}</p>
                <p class="description" [ngClass]="{'description-int': isInternationalSearch }">{{
                    pageData.gtpCardInitialState }}</p>
            </div>
            <div class="card" *ngIf="showGtpInEligibleCard">
                <div class="header-container">
                    <xm-media-image aria-hidden="true" [imageOptions]="inEligibleIcon" size="auto"></xm-media-image>
                    <p class="header">{{ pageData.gtpCardHeader }}</p>
                </div>
                <p class="description desc-extra-height" [ngClass]="{'description-int': isInternationalSearch }">{{ gtpIneligibleText }}</p>
                <div *ngIf="isMexCan" class="can-mex-cta" (click)="onCanMexCtaClick()">
                    <cms-text [originalText]="canMexCta"></cms-text>
                </div>
            </div>
            <div class="card" *ngIf="showGtpEligibleCard">
                <div class="header-container">
                    <xm-media-image aria-hidden="true" [imageOptions]="eligibleIcon" size="height"></xm-media-image>
                    <p class="header">{{ pageData.gtpCardHeader }}</p>
                </div>
                <div class="description" [ngClass]="{'description-int-searched': isInternationalSearch }">
                    <p>{{ isTmoAccount ? pageData.gtpCbmTmoEligibleText : gtpEligibleText }}</p>
                    <button *ngIf="showGtpLink && !isTmoAccount" class="xm-btn-link-light" (click)="launchGtpFlow()">{{
                        pageData.getGtpText }}</button>
                </div>
                <div class="rates-container">
                    <div class="type" *ngFor="let detail of pageData.gtpRateDetails">
                        <p class="label">{{ detail.label}}</p>
                        <p class="amount">{{ detail.price}}</p>
                        <p class="subtext">{{ detail.subtext}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-container" *ngIf="!enableCbmGeminiTR4">
            <div class="initial-card" *ngIf="showInitialState; else resultState">
                <p class="header">{{ pageData.payAsGoCardHeader }}</p>
                <p class="description" [ngClass]="{'description-int': isInternationalSearch }">{{
                    pageData.payAsGoCardInitialState }}</p>
            </div>
            <ng-template #resultState>
                <div class="card">
                    <p class="header">{{ pageData.payAsGoCardHeader }}</p>
                    <p class="description" [ngClass]="{'description-int-searched': isInternationalSearch }">{{
                        payAsGoCardResultState}}</p>
                    <div class="rates-container">
                        <div class="type" *ngFor="let detail of payAsGoRateDetails">
                            <p class="label">{{ detail.label}}</p>
                            <p class="amount">{{ detail.price}}</p>
                            <p class="subtext">{{ detail.subtext}}</p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <ng-template #noCoverageTemplate>
        <div class="no-coverage-card" [ngClass]="{'no-coverage-card-int': isInternationalSearch }">
            <p class="no-coverage-header">{{ pageData.noCoverageHeader }}</p>
            <p class="no-coverage-desc">{{ noCoverageDescription }}</p>
        </div>
    </ng-template>
</section>
